import styled from 'styled-components';
import { breakPoints } from '~/styles/break-points';

export const ConfigurationOverviewStyle = styled.section`
	padding: 48px 0;
	background: white;
	position: relative;
	display: flex;
	flex-direction: column;
	gap: 48px;
	align-items: center;

	${breakPoints({
		'768': `
			padding: 64px 0;
		`,
	})}

	${breakPoints({
		'1024': `
			padding: 72px 0;
		`,
	})}

	${breakPoints({
		'1440': `
			padding: 88px 0;
		`,
	})}

	.btn-group {
		& > div {
			display: flex;
			flex-direction: column;
			${breakPoints({
				'1024': `
					flex-direction: row;
					flex-wrap: wrap;
				`,
			})}
		}

		&--summary > div button {
			width: 100%;
		}
	}
`;

export const ConfigurationSummaryStyle = styled.section`
	column-gap: 3.5rem;
	display: flex;
	flex-direction: column;
	max-width: 1248px;
	row-gap: 36px;
	padding-bottom: 88px;
	background: white;

	${breakPoints({
		'768': `
		padding-bottom: 104px;
				`,
		'1024': `
		padding-bottom: 120px;
		display: grid;
		grid-template-columns: 413px 1fr 1fr;
				`,
	})}
`;

export const ConfigurationSectionWrapperStyle = styled.div`
	display: flex;
	flex-direction: column;
	grid-column: span 1 / span 1;
	row-gap: 40px;

	& .summary-section {
		display: flex;
		flex-direction: column;
		grid-column: span 1 / span 1;
		row-gap: 32px;
	}

	.button-group {
		display: flex;
		flex-direction: column;
		gap: 16px;
	}
`;

export const ConfigurationImageWrapperStyle = styled.div`
	grid-column: span 2 / span 2;
`;

export const ConfigurationImagesStyle = styled.div`
	display: grid;
	position: sticky;
	top: 16px;
	gap: 0.5rem;
`;

export const ConfigurationOverviewPriceWrapperStyle = styled.div`
	display: grid;
	row-gap: 0.5rem;
	column-gap: 4rem;
	grid-template-columns: 1fr;

	${breakPoints({
		'375': `
			grid-template-columns: auto auto;
		`,
	})}

	& .summary__price-headline,
	& .summary__price-value {
		display: flex;
		grid-column: 1;
	}
	& .summary__price-value {
		grid-column: 1;
		text-align: right;

		${breakPoints({
			'375': `
				justify-content: flex-end;
				grid-column: 2;
			`,
		})}
	}
	& .summary__omnibus-container {
		grid-column: 1 / -1;
		display: flex;
		margin-left: auto;
		button {
			display: flex;
			align-items: center;
			text-decoration: none;
		}
	}
`;
